<template>
  <path
    d="M9.9 3.82879L14.142 8.07179L4.242 17.9708H0V13.7278L9.9 3.82779V3.82879ZM11.314 2.41479L13.435 0.292787C13.6225 0.105316 13.8768 0 14.142 0C14.4072 0 14.6615 0.105316 14.849 0.292787L17.678 3.12179C17.8655 3.30931 17.9708 3.56362 17.9708 3.82879C17.9708 4.09395 17.8655 4.34826 17.678 4.53579L15.556 6.65679L11.314 2.41479Z"
    fill="currentColor"
  />
</template>
